import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.357 5H3.643A.64.64 0 0 0 3 5.643V18.5c0 .356.287.643.643.643h16.714A.64.64 0 0 0 21 18.5V5.643A.64.64 0 0 0 20.357 5m-.803 2.226v10.47H4.446V7.226l-.554-.432.79-1.015.86.67H18.46l.86-.67.789 1.015zm-1.093-.78L12 11.47 5.54 6.446l-.86-.669-.79 1.015.554.432 6.863 5.336a1.125 1.125 0 0 0 1.38 0l6.867-5.334.554-.432-.79-1.015z"
    }, null, -1)
  ])))
}
export default { render: render }